module.exports = __webpack_public_path__ + "app-static/img/07.d268e8d6.jpg";